import { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import CustomFilter from "./CustomFilter";
import LayerFilter from "./LayerFilter";
import AdditionalLayer from "./AdditionalLayer";
import APIHelper from "@giscon/utils.api-helper-esri";
import LayerStore from "@giscon/utils.layer-store";

import { Box, Button, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import AccordionPanel from "../components/AccordionPanel";
import HistoryViewer from "./HistoryViewer";
import { Share } from "@giscon/ui.share/dist/share";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import ExternLayers from "./ExternLayers";
import { BBStore } from "SandboxViewerComponent/src/stores/UiStore";
import HelpLink from "./HelpLink";
import FilterSelectionHint from "./FilterSelectionHint";
import { getCurrentFilterValues } from "utils/statistic";

const { token } = LayerStore;

const MapFilter = (props) => {
  const [layers, setLayers] = useState([]);
  const dropDownFilterAnchorRef = useRef(null);

  const { Kategorie, Parameter, Zeitabschnitt } =
    getCurrentFilterValues(props.CommunicationStore) || {};

  // Derive downloadUrl from the currently selected Parameter item.
  // The backend may provide a `downloadUrl` property on Parameter-level choices.
  const getFilterConfig = props.CommunicationStore.getMessagesToID({
    to: "filterAccess",
  })?.message;
  const parameterAccess = getFilterConfig?.("Parameter");
  const _rawDownloadUrl =
    parameterAccess?.items?.[parameterAccess?.index]?.downloadUrl;
  const downloadUrl =
    typeof _rawDownloadUrl === "string" && _rawDownloadUrl
      ? _rawDownloadUrl
      : null;

  /**
   * Returns contextual hint message for the next required dropdown selection.
   * @returns {string} Hint message or empty string if all dropdowns are selected.
   */
  const getHintMessage = () => {
    if (!Kategorie) return "Bitte Kategorie auswählen.";
    if (!Parameter) return "Bitte Parameter auswählen.";
    if (!Zeitabschnitt) return "Bitte Zeitabschnitt auswählen.";
    return "";
  };

  const hintMessage = getHintMessage();

  // Read services during render so MobX can track changes.
  // Do not wrap this in useMemo, otherwise the observable read can be skipped.
  const services =
    props.CommunicationStore.getMessagesToID({
      to: "regionalSelectionServices",
    })?.message || [];

  // Create layers when services are loaded
  useEffect(() => {
    if (!Array.isArray(services) || services.length === 0) {
      setLayers([]);
      return;
    }

    setLayers(
      services
        .filter(
          (s) => s?.ShowInAdditionalMap === true && s.Url && s.NameAdditionalMap
        )
        .map(({ Url, NameAdditionalMap }) =>
          APIHelper.createImageLayer(
            { name: NameAdditionalMap, url: Url },
            { token }
          )
        )
    );
  }, [services]);

  return (
    <>
      <HelpLink
        url="/hauptfunktionen/werkzeugleiste/thema-auswaehlen"
        style={{
          position: "absolute",
          right: 16,
          top: 16,
        }}
      />
      <Box
        style={{
          marginBottom: 10,
          paddingTop: 10,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div id="dropDownFilterParams" ref={dropDownFilterAnchorRef}>
            <CustomFilter {...props} /> {/*DropDown-Filter-Anzeige*/}
          </div>
          {downloadUrl && (
            <Button
              variant="contained"
              href={downloadUrl}
              target="_blank"
              style={{ marginTop: 20, marginRight: 28 }}
              endIcon={<DownloadIcon />}
            >
              Download der Daten
            </Button>
          )}
        </div>
        <FilterSelectionHint
          anchorEl={dropDownFilterAnchorRef.current}
          open={Boolean(hintMessage) && Boolean(props.opened)}
          message={hintMessage}
        />

        {BBStore.mobile && (
          <Button
            color="primary"
            style={{ marginTop: 10 }}
            variant="contained"
            onClick={() => {
              props.CommunicationStore.closeWidget("mapFilter");
              props.CommunicationStore.openWidget("stats");
            }}
          >
            {"Zum Faktenblatt wechseln"}
          </Button>
        )}
      </Box>
      <LayerFilter {...props} /> {/*Anzeige der Layer in der Map + Legende*/}
      <AccordionPanel
        summary={
          <>
            <Typography>Teilen</Typography>
            <HelpLink
              className="help-link"
              size="20px"
              url="/hauptfunktionen/werkzeugleiste/teilen"
            />
          </>
        }
      >
        <Share
          shareUrl={RootStore.history?.[0]?.url || ""}
          enableMailTo
          enableQrcode
          shortenerUrl={
            "https://urls.niedersachsen.de/yourls-api.php?signature=44d15ac09f&action=shorturl&format=json&url="
          }
          shortenerRequestOptions={{
            requestUrlGenerator: (url, data) => {
              return url + encodeURIComponent(data);
            },
            getResultString: (response) => {
              return new Promise((resolve, reject) => {
                response
                  .json()
                  .then((json) => {
                    if (json.status === "success") {
                      resolve(json.shorturl);
                    } else {
                      reject(JSON.stringify(json));
                    }
                  })
                  .catch((e) => {
                    reject(e);
                  });
              });
            },
          }}
        />
      </AccordionPanel>
      <HistoryViewer CommunicationStore={props.CommunicationStore} />
      <AccordionPanel summary={<Typography>Karten hinzufügen</Typography>}>
        <AdditionalLayer {...props} layers={layers} />
        <ExternLayers proxy={props?.WMSProxy} />
      </AccordionPanel>
      {/* <RasterStatistics
          {...this.props}
          style={{ padding: 20 }}
          decimalPlaces={2}
        /> */}
      {/* {
          this.props.CommunicationStore.getMessagesToID({ toId: "shownLayers" })
            ?.message?.layerInfos[0]?.layerId
        } */}
      {/* <OverviewMap {...this.props} /> */}
    </>
  );
};
export default observer(MapFilter);
